import React from 'react';
import PropTypes from 'prop-types';

import BreedSelect from 'dpl/common/components/BreedSelect';
import { isMobileUA } from 'dpl/shared/utils';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

const IS_MOBILE_UA = isMobileUA();

export default function BreedDropdown({
  breedOptions,
  handleBreedSelect,
  selectedBreedId,
  isVisible,
  closeDropdown
}) {
  if (IS_MOBILE_UA) {
    return (
      <div className="MobileBreedDropdown h-100 w-100">
        <FixedTooltipPortal
          isVisible={isVisible}
          onCloseClick={closeDropdown}
          wrapperClassName="MobileBreedDropdown__tooltip"
          className="h-100 no-scrollbars pt12 ph5"
          shouldHideCloseButton
        >
          <BreedSelect
            availableBreeds={breedOptions}
            onSelect={handleBreedSelect}
            selectedId={selectedBreedId}
            className="overflow-scroll"
            newDesignSystemStyles
            defaultIsOpen
            placeholder="Search breed"
          />
        </FixedTooltipPortal>
      </div>
    );
  }

  return (
    <div className="BreedDropdownWrapper relative z-max">
      <div className="BreedDropdown bg-white w-100 h-100 no-scrollbars br4 ba b--default ph4 pv4">
        <BreedSelect
          availableBreeds={breedOptions}
          onSelect={handleBreedSelect}
          selectedId={selectedBreedId}
          className="overflow-scroll"
          newDesignSystemStyles
          defaultIsOpen
          placeholder="Search breed"
        />
      </div>
    </div>
  );
}

BreedDropdown.propTypes = {
  breedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      cover_photo_url: PropTypes.string.isRequired
    })
  ).isRequired,
  handleBreedSelect: PropTypes.func.isRequired,
  selectedBreedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isVisible: PropTypes.bool.isRequired,
  closeDropdown: PropTypes.func.isRequired
};

BreedDropdown.defaultProps = {
  selectedBreedId: null
};
